import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { payments } from '../lib/api';
import { CheckCircle2, Loader2, XCircle } from 'lucide-react';

export default function PaymentReturn() {
  const [sp] = useSearchParams();
  const sessionId = sp.get('session_id');
  const orderId = sp.get('order_id');
  const paypalToken = sp.get('provider') === 'paypal' ? sp.get('token') : null;
  const [state, setState] = useState({ status: 'checking', payment_status: null });
  const nav = useNavigate();

  useEffect(() => {
    if (!paypalToken) return;
    payments.paypalCapture(paypalToken)
      .then(s => { setState(s); if (s.payment_status === 'paid') setTimeout(() => nav(`/orders/${s.order_id}`), 1200); else setState({ status: 'error', payment_status: 'failed' }); })
      .catch(() => setState({ status: 'error', payment_status: 'error' }));
  }, [paypalToken, nav]);

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const s = await payments.stripeStatus(sessionId);
        if (s.payment_status === 'paid') { setState(s); setTimeout(() => nav(`/orders/${s.order_id}`), 1200); return; }
        if (s.status === 'expired' || attempts >= 6) { setState(s); return; }
        setTimeout(poll, 2000);
      } catch {
        if (attempts < 6) setTimeout(poll, 2000); else setState({ status: 'error', payment_status: 'error' });
      }
    };
    poll();
  }, [sessionId, nav]);

  return (
    <div className="max-w-md mx-auto px-6 py-24 text-center">
      {state.payment_status === 'paid' ? (
        <>
          <CheckCircle2 className="w-16 h-16 mx-auto text-[#2E7D32]"/>
          <h1 className="font-heading font-black text-3xl mt-4">Payment successful!</h1>
          <p className="text-ink/70 mt-2">Redirecting you to your order…</p>
        </>
      ) : state.status === 'expired' || state.status === 'error' ? (
        <>
          <XCircle className="w-16 h-16 mx-auto text-destructive"/>
          <h1 className="font-heading font-black text-3xl mt-4">Payment not completed</h1>
          <button onClick={() => nav(`/orders/${orderId || ''}`)} className="btn-outline mt-5">View order</button>
        </>
      ) : (
        <>
          <Loader2 className="w-12 h-12 mx-auto animate-spin text-[#E67E22]"/>
          <h1 className="font-heading font-bold text-2xl mt-4">Confirming your payment…</h1>
          <p className="text-ink/60 mt-2 text-sm">Please don't close this tab.</p>
        </>
      )}
    </div>
  );
}
